// extracted by mini-css-extract-plugin
module.exports = {"Navigation-button":"navigation-button_Navigation-button__WqGu4"};